import { Component, inject } from '@angular/core'
import { TranslocoPipe } from '@jsverse/transloco';
import { FormsModule } from '@angular/forms';
import { DatePipe, NgIf } from '@angular/common';
import {
  DateRange,
  extractDefaultStoreId,
  extractNumber, HxFioPipe,
  HxReportService,
  HxUiLabelPipe,
  InvoiceModel,
} from 'hx-services';
import { ActivatedRoute } from '@angular/router';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { HxLoaderComponent } from 'hx-component';
import { DataService } from '@manager-app/service/data.service';
import { HcIconComponent } from '@manager-app/components/hc-icon/hc-icon.component';
import { NgbModal, NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { InvoiceModalComponent } from '@manager-app/modal/invoice/invoice.modal';

@Component({
  selector: 'app-inventory-management',
  templateUrl: './invoice-info.component.html',
  imports: [
    TranslocoPipe,
    FormsModule,
    HxUiLabelPipe,
    HxLoaderComponent,
    DatePipe,
    HxFioPipe,
    HcIconComponent,
    NgIf,
    NgbTooltip,
  ],
  styleUrls: ['./invoice-info.component.css']
})
export class InvoiceInfoComponent {
  params: {
    storeId?: number,
    date?: DateRange,
    type?: string;
    productInfoId?: number;
  } = {};
  isLoading = {
    list: false,
  };
  invoices?: InvoiceModel[] = [];
  statusList = DataService.statusList;

  private readonly reportService = inject(HxReportService);
  private readonly aRoute = inject(ActivatedRoute);
  private readonly modalService = inject(NgbModal);

  constructor() {
    this.aRoute.queryParamMap.pipe(takeUntilDestroyed()).subscribe(async paramMap => {
      this.params.date = {from: paramMap.get('dateFrom'), to: paramMap.get('dateTo')};
      this.params.type = paramMap.get('type');
      this.params.storeId = extractNumber('storeId', paramMap) ?? extractDefaultStoreId();
      this.params.productInfoId = extractNumber('productInfoId', paramMap);
      if (this.params.storeId) {
        this.load();
      }
    });
  }

  async load() {
    this.isLoading.list = true;
    try {
      this.invoices = await this.reportService.getInvoiceInfoReports({
        fromDate: this.params.date.from,
        toDate: this.params.date.to,
        storeId: this.params.storeId,
        productInfoIds: [this.params.productInfoId],
        type: this.params.type
      });

    } finally {
      this.isLoading.list = false;
    }
  }

  showInvoiceModal(invoice: InvoiceModel) {
    const modalRef = this.modalService.open(InvoiceModalComponent, {size: 'lg'});
    modalRef.componentInstance.invoice = invoice;
  }
}
